const FallbackLoading = () => <div className="fallback-loading" />;
export default FallbackLoading;
